// Who the entitlements cache belongs to: the signed-in tenant + user, read from
// the Redux store (auth.user, tenant.current). '' = signed out. Kept in its own
// module so useEntitlements stays testable without the whole app store.
import { store } from '@/app/store';

type IdentityState = {
  auth?: { user?: { id?: string } | null };
  tenant?: { current?: { id?: string } | null };
};

export function currentIdentityKey(): string {
  const s = store.getState() as unknown as IdentityState;
  const user = s.auth?.user?.id ?? '';
  if (!user) return '';
  return `${s.tenant?.current?.id ?? ''}|${user}`;
}

export function subscribeIdentity(cb: () => void): () => void {
  return store.subscribe(cb);
}
